/** Helpers instancias fiscales (compliance_instances). */

export const COMPLIANCE_STATUS_OPTIONS = [
  { value: "pending", label: "Pendiente" },
  { value: "requested", label: "Solicitado" },
  { value: "in_progress", label: "En proceso" },
  { value: "done", label: "Terminado" },
  { value: "not_applicable_this_period", label: "No aplicó este mes" },
];

/** Estado editable en captura mensual (seguimiento anual). */
export const CAPTURE_STATUS_OPTIONS = [
  { value: "pending", label: "Pendiente" },
  { value: "in_progress", label: "En proceso" },
  { value: "done", label: "Cerrado" },
];

export const PERIOD_MODE_OPTIONS = [
  { value: "current_month", label: "Mes actual" },
  { value: "next_month", label: "Próximo mes" },
];

export const SCOPE_OPTIONS = [
  { value: "all", label: "Todas las empresas" },
  { value: "one", label: "Una empresa" },
];

export const OBLIGATION_FILTER_OPTIONS = [
  { value: "all_active", label: "Todas las obligaciones activas" },
];

export function complianceStatusLabel(status) {
  const found = COMPLIANCE_STATUS_OPTIONS.find((o) => o.value === status);
  if (found) return found.label;
  const legacy = {
    pendiente: "Pendiente",
    solicitado: "Solicitado",
    en_proceso: "En proceso",
    completada: "Terminado",
    no_aplico_este_mes: "No aplicó este mes",
  };
  return legacy[status] || status || "—";
}

export function complianceStatusVariant(status) {
  const norm = String(status || "").toLowerCase();
  if (norm === "done" || norm === "completada") return "success";
  if (norm === "not_applicable_this_period" || norm === "no_aplico_este_mes") return "secondary";
  if (norm === "in_progress" || norm === "en_proceso") return "warning";
  if (norm === "requested" || norm === "solicitado") return "default";
  return "secondary";
}

export function obligationSourceLabel(source) {
  const map = {
    csf_suggested: "CFS",
    csf_confirmed: "CFS",
    manual_assignment: "Manual",
    cfdi_detected: "CFDI detectado",
    system: "Sistema",
  };
  return map[source] || source || "—";
}

export const NOT_APPLICABLE_SUGGESTED_COMMENT =
  "No hubo operaciones aplicables en este periodo.";

export const NOT_APPLICABLE_RETENCIONES_COMMENT =
  "No se detectaron CFDI con retención en este periodo.";

export const FILING_TYPE_OPTIONS = [
  { value: "normal", label: "Declaración normal" },
  { value: "complementaria", label: "Declaración complementaria" },
];

/** Tipo declaración en captura mensual (incluye «No aplica» para obligaciones esporádicas). */
export const CAPTURE_FILING_TYPE_OPTIONS = [
  ...FILING_TYPE_OPTIONS,
  { value: "not_applicable_this_period", label: "No aplica este mes" },
];

export function isCaptureNotApplicable(filingType) {
  return String(filingType || "") === "not_applicable_this_period";
}

export function captureFilingTypeLabel(value) {
  const found = CAPTURE_FILING_TYPE_OPTIONS.find((o) => o.value === value);
  if (found) return found.label;
  return filingTypeLabel(value);
}

export const FILING_VIEW_TABS = [
  { value: "seguimiento_anual", label: "Seguimiento de tareas" },
  { value: "auxiliar", label: "Resumen auxiliar" },
  { value: "mis", label: "Pendientes del mes" },
  { value: "empresa", label: "Por empresa" },
  { value: "declared", label: "Declaradas" },
  { value: "complementaria_pending", label: "Complementarias por pagar" },
];

export function filingTypeLabel(value) {
  const found = FILING_TYPE_OPTIONS.find((o) => o.value === value);
  return found?.label || "Sin declarar";
}

export function taskMatchesFilingView(task, view) {
  if (!view || view === "mis" || view === "empresa" || view === "auxiliar" || view === "seguimiento_anual") return true;
  if (view === "declared") return Boolean(task.is_declared);
  if (view === "complementaria_pending") return Boolean(task.complementaria_pending);
  // followup_sent / recordatorios_aux viven en Calendario (Recordatorios), no en Fiscales.
  if (view === "followup_sent") {
    return Boolean(task.client_followup_sent) || task.client_reminder_status === "sent";
  }
  if (view === "recordatorios_aux") return true;
  return true;
}

export function instanceMatchesFilingView(instance, view) {
  if (!view || view === "mis" || view === "empresa" || view === "auxiliar" || view === "seguimiento_anual") return true;
  if (view === "declared") return Boolean(instance.is_declared);
  if (view === "complementaria_pending") return Boolean(instance.complementaria_pending);
  if (view === "followup_sent") {
    return Boolean(instance.client_followup_sent) || instance.client_reminder_status === "sent";
  }
  if (view === "recordatorios_aux") return true;
  return true;
}
